<template>

    <v-modal
        :open="open"
        class="c-modal_remove_patient">
        <h2>Usuń wizytę z bazy danych</h2>
        <p class="c-modal_remove_patient__content">Czy na pewno chcesz usunąć wybraną wizytę?</p>
        <div>
            <v-btn
                type="red-white"
                @click="cancel">
                Anuluj
            </v-btn>
            <v-btn
                type="red"
                @click="ok"
                has-loader
                :loading="isLoading">
                Tak, usuń
            </v-btn>
        </div>
    </v-modal>

</template>


<script>

import VModal from 'Components/VModal'
import VBtn from 'Components/VBtn'

export default {

    name: 'VisitRemoveModal',

    data() {
        return {
            visitId: null,
            open: false,
            isLoading: false
        }
    },

    methods: {
        cancel() {
            this.open = false
            this.$emit('cancel')
        },

        ok() {
            this.isLoading = true
            this.$emit('ok', this.visitId, this.closeModal)
        },
        closeModal() {
            this.isLoading = false
            this.open = false
        }
    },

    mounted() {
        this.$on('open', (id) => {
            this.visitId = id
            this.open = true
        })
    },

    beforeDestroy() {
        this.$off('open')
    },

    components: {
        VModal,
        VBtn
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-modal_remove_patient {
    text-align: center;

    &__content {
        margin: 1.5em 0;
    }
    &__question {
        color: $c-red;
        margin-bottom: 2em;
    }
    button {
        margin: .5em;
    }
}

</style>
